// extracted by mini-css-extract-plugin
export default {"root":"counter_tile-module___root___b705ebb5","counter":"counter_tile-module___counter___a93cadb4","title":"counter_tile-module___title___b8f110bf"};